import React, { useMemo } from "react";
import { clampInt } from "./settlementRules";
function SectionBox({ title, subtitle, children }) {
  return (
    <div style={{ border: "1px solid #ddd", padding: 12 }}>
      <h3 style={{ marginTop: 0 }}>{title}</h3>
      {subtitle ? (
        <div style={{ marginTop: -6, fontSize: 13, opacity: 0.85 }}>{subtitle}</div>
      ) : null}
      {children}
    </div>
  );
}

function TwoCharNumber({ value, onChange, title }) {
  return (
    <input
      className="twoCharBox"
      type="number"
      title={title}
      value={clampInt(value, 0, 99)}
      onChange={(e) => onChange(clampInt(e.target.value, 0, 99))}
      style={{ padding: "6px 8px", fontSize: 14 }}
    />
  );
}

// ✅ clickable checkbox grid (Death Count / Lost Settlements)
function CheckboxGrid({ values, columns, boldIndexes = [], onToggle, compact = true }) {
  const boldSet = useMemo(() => new Set(boldIndexes), [boldIndexes]);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, ${compact ? "18px" : "22px"})`,
        gap: compact ? 6 : 8,
        marginTop: 8,
        alignItems: "center",
      }}
    >
      {values.map((v, i) => (
        <input
          key={i}
          type="checkbox"
          checked={!!v}
          onChange={() => onToggle(i)}
          style={{
            width: compact ? 18 : 22,
            height: compact ? 18 : 22,
            margin: 0,
            cursor: "pointer",
            outline: boldSet.has(i) ? "2px solid #000" : "1px solid #bbb",
            outlineOffset: -2,
          }}
        />
      ))}
    </div>
  );
}

function CardText({ entry }) {
  if (!entry) return null;

  const name = entry.name || entry.title || "";
  const traits = entry.traits || "";
  const rules = entry.rules || entry.effect || entry.description || entry.text || "";
  const observationCondition = entry.observationCondition || "";
  const lumiCost = entry.lumiCost;

  return (
    <div style={{ fontSize: 13, lineHeight: 1.35, opacity: 0.95, marginTop: 6 }}>
      {name ? (
        <div style={{ marginBottom: 4 }}>
          <b>{name}</b>
        </div>
      ) : null}

      {traits ? (
        <div>
          <b>Traits:</b> {traits}
        </div>
      ) : null}

      {rules ? (
        <div style={{ marginTop: traits ? 4 : 0, whiteSpace: "pre-wrap" }}>
          {traits ? <b>Rules:</b> : null} {rules}
        </div>
      ) : null}

      {observationCondition ? (
        <div style={{ marginTop: 4 }}>
          <b>Observation:</b> {observationCondition}
        </div>
      ) : null}

      {lumiCost !== undefined && lumiCost !== null ? (
        <div style={{ marginTop: 4 }}>
          <b>Lumi Cost:</b> {lumiCost}
        </div>
      ) : null}
    </div>
  );
}

// ✅ Innovation/Principle renderer (uses entry.text)
function InnovationCardText({ entry }) {
  if (!entry) return null;

  const name = entry.name || entry.title || "";
  const type = entry["innovation type"] || entry.innovationType || "";
  const consequenceOf = entry["consequence of"] || entry.consequenceOf || "";
  const expansion = entry.expansion || "";
  const body = entry.text || entry.rules || entry.effect || entry.description || "";

  return (
    <div style={{ marginTop: 6, fontSize: 13, lineHeight: 1.35, opacity: 0.95 }}>
      {name ? (
        <div style={{ marginBottom: 4 }}>
          <b>{name}</b>
        </div>
      ) : null}

      {type ? (
        <div>
          <b>Type:</b> {type}
        </div>
      ) : null}

      {consequenceOf ? (
        <div style={{ marginTop: 2 }}>
          <b>Consequence of:</b> {consequenceOf}
        </div>
      ) : null}

      {expansion ? (
        <div style={{ marginTop: 2 }}>
          <b>Expansion:</b> {expansion}
        </div>
      ) : null}

      {body ? <div style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>{body}</div> : null}
    </div>
  );
}


export { SectionBox, TwoCharNumber, CheckboxGrid, CardText, InnovationCardText };
